<div mat-dialog-title>
  <h2 class="modal-title" *ngIf="!data.record">{{ 'users.Create user' | translate }}</h2>
  <h2 class="modal-title" *ngIf="data.record && userDetails">{{ 'users.Update user' | translate }} "{{
    userDetails.name }}"
  </h2>
  <button mat-icon-button class="close" [disabled]="loading" aria-label="Close" (click)="openConfirmDialog()">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<form [formGroup]="formGroup">
  <mat-dialog-content>

    <div *ngIf='dataLoading' class="dataLoading py-5">
      <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <div class="mat-dialog-body" *ngIf="!dataLoading">

      <div class="mat-dialog-inner">
        <div class="fields-group">
          <div class="image-uploader">
            <div class="upload-container">
              <label [for]="'fileUploadInput'">
                <input type='file' class="img-viewer" [id]="'fileUploadInput'" accept=".png, .jpg, .jpeg"
                  (change)="changeFileListener($event)">
                <div class="image-preview photo squared">
                  <div class="remove-img" *ngIf="imageSrc" (click)="removeImg($event)">
                    <mat-icon>close</mat-icon>
                  </div>
                  <img [src]="imageSrc" *ngIf="imageSrc">
                </div>
              </label>
            </div>
            <div>
              <label>{{ 'users.profileImage' | translate }}</label>
              <p>
                {{ 'forms.JPG or PNG' | translate }}
                <span>({{ 'forms.MB max' | translate: {no: 2} }})</span>
              </p>
              <label [for]="'fileUploadInput'">
                <a>{{'forms.Upload/Select File' | translate }}</a>
              </label>
            </div>
          </div>
          <!-- <p class="has-error" *ngIf="!logoSrc && isSubmitted && !(fileTypeError || fileSizeError)">
            {{ 'forms.Required' | translate }}
          </p> -->
          <p class="has-error" *ngIf="fileTypeError">{{ 'forms.InvalidFile' | translate }}</p>
          <p class="has-error" *ngIf="fileSizeError">{{ 'forms.Max-file-size' | translate }} {{maxFileSize}} {{
            'forms.MB' | translate }}</p>
        </div>

      </div>
      <div class="mat-dialog-inner">
        <h3 class="subtitle-form">
          {{ 'users.personalTab' | translate }}
        </h3>
        <div class="form-group">
          <mat-form-field>
            <mat-label> {{ 'fields.englishName' | translate }}</mat-label>
            <input matInput placeholder="" value="" formControlName="fullEnglishName" maxlength="50">
            <mat-error *ngIf="hasError('fullEnglishName', 'required')">
              {{ 'register.fullNameMsg' | translate }}
            </mat-error>
            <mat-error *ngIf="hasError('fullEnglishName', 'pattern')">
              {{ 'register.fullNameMsg' | translate }}
            </mat-error>
            <mat-error *ngIf="hasError('fullEnglishName', 'minlength') && !hasError('fullEnglishName', 'pattern')">
              {{ 'users.nameMustBe' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field>
            <mat-label>{{ 'fields.arbicName' | translate }}</mat-label>
            <input matInput placeholder="" value="" formControlName="fullArabicName" required maxlength="50">
            <mat-error *ngIf="hasError('fullArabicName', 'required')">
              {{ 'messages.nameArRequired' | translate }}
            </mat-error>
            <mat-error *ngIf="hasError('fullArabicName', 'minlength') && !hasError('fullArabicName', 'pattern')">
              {{ 'users.nameMustBe' | translate }}
            </mat-error>
            <mat-error *ngIf="hasError('fullArabicName', 'pattern')">
              {{ 'messages.nameArRequired' | translate }}
            </mat-error>

          </mat-form-field>
        </div>
        <!-- <div class="form-group">
          <div class="budge-control">
            <label for="budge-file" class="budge-container" [for]="'fileUploadInput'">
              <input type="file" accept=".png, .jpg, .jpeg" class="img-viewer" [id]="'fileUploadInput'"
                (change)="changeFileListener($event)">
              <span class="icon">
                <svg width="10" height="10" viewBox="0 0 10 10">
                  <path id="plus-icon"
                    d="M9.318,4.091H5.909V.682A.682.682,0,0,0,5.227,0H4.773a.682.682,0,0,0-.682.682V4.091H.682A.682.682,0,0,0,0,4.773v.455a.682.682,0,0,0,.682.682H4.091V9.318A.682.682,0,0,0,4.773,10h.455a.682.682,0,0,0,.682-.682V5.909H9.318A.682.682,0,0,0,10,5.227V4.773A.682.682,0,0,0,9.318,4.091Zm0,0"
                    fill="#fff" />
                </svg>
              </span>
              <span class="img-container">
                <img [src]="imageSrc" *ngIf="imageSrc">
              </span>
            </label>
            <div class="msg">
              {{ 'users.profileImage' | translate }}
            </div>
          </div>
          <p class="has-error" *ngIf="fileSizeError || fileTypeError">{{ 'messages.profileImageInvalid' | translate}}
           </p>
        </div> -->

        <!-- Date Picker -->
        <div class="form-group">
          <mat-form-field>
            <mat-label>{{ 'fields.dateBirth' | translate }}</mat-label>
            <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="dateOfBirth" formControlName="dateOfBirth"
              readonly (focus)="dateOfBirth.open()">
            <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
            <!-- <mat-icon matDatepickerToggleIcon *ngIf="formGroup.get('dateOfBirth')?.value" class="p-0"
              (click)="clearDate($event)" matSuffix>clear</mat-icon> -->
            <mat-datepicker #dateOfBirth></mat-datepicker>
            <mat-error *ngIf="hasError('dateOfBirth', 'required')">{{ 'messages.dobRequired' | translate
              }}</mat-error>
            <mat-error *ngIf="hasError('dateOfBirth', 'matDatepickerMax')">{{ 'messages.dateInferior' |
              translate
              }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-form-field>
            <mat-label>{{ 'fields.Identification Number' | translate }}</mat-label>
            <input matInput appOnlynumber maxlength="10" formControlName="identityNumber" required>
            <mat-error *ngIf="hasError('identityNumber', 'required')">{{ 'messages.idNumberRequired' | translate
              }}</mat-error>
            <mat-error *ngIf="hasError('identityNumber', 'pattern')">{{ 'messages.nationalIdMustBeTenDigitsStartingWithOneOrTwo' | translate
              }}</mat-error>
            <mat-error *ngIf="hasError('identityNumber', 'notUniqe')">
              {{ 'messages.idNumberAlreadyRegistered' | translate}}
            </mat-error>
          </mat-form-field>
        </div>
        <h3 class="subtitle-form">{{ 'fields.gender' | translate }}:</h3>
        <div class="radio-selector">
          <mat-radio-group formControlName="genderEnum">
            <div class="row">
              <div class="col-6">
                <mat-radio-button [value]="genderEnum.MALE">{{ 'fields.male' | translate }}</mat-radio-button>
              </div>
              <div class="col-6">
                <mat-radio-button [value]="genderEnum.FEMALE">{{ 'fields.female' | translate }}</mat-radio-button>
              </div>
            </div>
          </mat-radio-group>

        </div>
      </div>


      <div class="mat-dialog-inner">
        <h3 class="subtitle-form">
          {{ 'users.accountTab' | translate }}
        </h3>
        <div class="form-group">
          <!-- emailmodelChanged($event, userID) -->
          <mat-form-field>
            <mat-label> {{ 'fields.email' | translate }}</mat-label>
            <input matInput type="email" formControlName="email" placeholder="Ex. pat@example.com"
              [disabled]='data.record ? true : false' maxlength="100">
            <mat-error *ngIf="hasError('email', 'required')">
              {{ 'messages.emailRequiredAndValid' | translate }}
            </mat-error>
            <mat-error *ngIf="hasError('email', 'pattern') && !hasError('email', 'required')">
              {{ 'forms.Invalid-Email' | translate }}
            </mat-error>
            <mat-error *ngIf="hasError('email', 'notUniqe') && !hasError('email', 'required')">
              {{ 'messages.uniqeEmail' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="mat-dialog-inner">
        <h3 class="subtitle-form">
          {{ 'users.contactTab' | translate }}
        </h3>
        <div class="form-group">
          <mat-form-field>
            <mat-label>{{ 'fields.country' | translate }}</mat-label>
            <mat-select formControlName="countryId" (selectionChange)="getCitiesId($event)">
              <mat-option *ngFor="let country of countries" [value]="country.id"> {{country.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('countryId', 'required')">{{ 'messages.countryRequired' |
              translate
              }}</mat-error>
          </mat-form-field>
        </div>
        <div class="form-group">
          <mat-form-field>
            <mat-label>{{ 'fields.city' | translate }}</mat-label>
            <mat-select formControlName="cityId" [disabled]="!enableCity">
              <mat-option *ngFor="let city of cities" [value]="city.id">
                {{city.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('cityId', 'required')">{{ 'messages.cityRequired' | translate
              }}</mat-error>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-form-field class="phoneNumberleft">
            <mat-label>{{ 'fields.phoneNumber' | translate }}</mat-label>
            <input matInput formControlName="phoneNumber" appOnlynumber maxlength="9" minlength="9">
            <span matSuffix>{{countryKey}} </span>
            <mat-error *ngIf="hasError('phoneNumber', 'required')">{{ 'messages.mobileNumberRequiredAndValid' |
              translate }}</mat-error>
            <mat-error *ngIf="hasError('phoneNumber', 'notUniqe')">{{ 'auth.phoneAlreadyExists' | translate
              }}</mat-error>
            <mat-error *ngIf="hasError('phoneNumber', 'pattern')">
              {{ 'forms.invalidPhoneNumber' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" [disabled]="loading" class="btn-grey" (click)="openConfirmDialog()">
      {{"forms.Cancel" | translate}}
    </button>
    <button (click)="saveUser()" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
      {{"forms." + (data.record ? 'Update' : 'Add') | translate}}
    </button>
  </mat-dialog-actions>
</form>
